<template>
  <span @click="confirmDelete">
    <feather-icon
      icon="TrashIcon"
      size="15"
      color="red"
    />
  </span>
</template>

<script>
import axios from 'axios'

export default {
  props: {
    taskId: {
      type: [String, Number],
      required: true,
    },
    deleteUrl: {
      type: String,
      required: true,
    },
  },
  methods: {
    async callData() {
      this.$store.commit('generalData/allTaskManagments/setTaskLoaded', false)
    },
    confirmDelete() {
      const swalWithBootstrapButtons = this.$swal.mixin({
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger',
        },
        buttonsStyling: false,
      })

      this.$swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, cancel!',
        reverseButtons: true,
      }).then(async result => {
        if (result.isConfirmed) {
          try {
            const response = await axios.delete(`${this.deleteUrl}/${this.taskId}`)
            if (response.status === 200) {
              swalWithBootstrapButtons.fire('Deleted!', 'The task has been deleted.', 'success')
              await this.callData()
            } else {
              swalWithBootstrapButtons.fire('Error', 'Unexpected response from server.', 'error')
            }
          } catch (error) {
            if (error.response.status === 403) {
              swalWithBootstrapButtons.fire('Error', 'you don\'t have permation to delete this task', 'error')
            } else {
              swalWithBootstrapButtons.fire('Error', 'Something went wrong.', 'error')
            }
          }
        } else if (result.dismiss === this.$swal.DismissReason.cancel) {
          swalWithBootstrapButtons.fire('Cancelled', 'Your task is safe.', 'info')
        }
      })
    },
  },
}
</script>
<style>
.swal2-styled.swal2-confirm{
    margin-left: 5px;
}
</style>
